import React, { Fragment } from 'react';
import ReactDOM from 'react-dom'

import App from './components/App'
import theme from './utils/theme'
import GlobalStyle from './utils/global'

import { ThemeProvider } from 'styled-components'
import { Provider } from 'react-redux'
import { createStore, applyMiddleware, compose } from 'redux'
import reduxThunk from 'redux-thunk'

import reducers from './reducers'
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(reducers, composeEnhancers(applyMiddleware(reduxThunk)))

// const store = createStore(reducers, applyMiddleware(thunk))

ReactDOM.render(
    <Provider store={store}>
        <ThemeProvider theme={theme}>
            <Fragment>
                <App />
                <GlobalStyle />
            </Fragment>
        </ThemeProvider>
    </Provider>,
    document.getElementById('root')
)




